import type { NavbarLink } from '@/components/Layout/Navbar/types'

export default function getActiveNavbarLink(
  items: NavbarLink[],
  currentPath: string
): NavbarLink | null {
  // Sort based on url length, we want to get
  // exact matches, so longest match wins
  const sortedItems = [...items].sort((a, b) => b.href.length - a.href.length)

  // Short-circuit on the first match
  for (let i = 0, { length } = sortedItems; i < length; i += 1) {
    const item = sortedItems[i]

    if (currentPath.startsWith(item.href)) {
      return item
    }
  }

  return null
}
